import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Inicio from "./pages/Inicio";
import Home from "./pages/Home";
import Historia from "./pages/Historia";
import Contato from "./pages/Contato";
import Agradecimentos from "./pages/Agradecimentos";

// Páginas da área de materiais teóricos
import HomeMateriais from "./pages/Materiais/HomeMateriais";
import CriacaoElementos from "./pages/Materiais/CriacaoElementos";

// Páginas da área de ferramentas numéricas
import HomeFerramentas from "./pages/Ferramentas/HomeFerramentas";
import DiagramaGama from "./pages/Ferramentas/DiagramaGama";
import DiagramaSaturacao from "./pages/Ferramentas/DiagramaSaturacao";
import DiagramaELV from "./pages/Ferramentas/DiagramaELV";
import MassaMolar from "./pages/Ferramentas/MassaMolar";
import TabelaPeriodica from "./pages/Ferramentas/TabelaPeriodica";

export default function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" exact component={Inicio}></Route>
                <Route path="/home" component={Home}></Route>
                <Route path="/historia" component={Historia}></Route>
                <Route path="/contato" component={Contato}></Route>
                <Route path="/agradecimentos" component={Agradecimentos}></Route>

                <Route path="/materiais" exact component={HomeMateriais}></Route>
                <Route path="/materiais/1" exact component={CriacaoElementos}></Route>

                <Route path="/ferramentas" exact component={HomeFerramentas}></Route>
                <Route path="/ferramentas/1" exact component={DiagramaGama}></Route>
                <Route path="/ferramentas/2" exact component={DiagramaSaturacao}></Route>
                <Route path="/ferramentas/3" exact component={DiagramaELV}></Route>
                <Route path="/ferramentas/4" exact component={MassaMolar}></Route>
                <Route path="/ferramentas/5" exact component={TabelaPeriodica}></Route>
            </Switch>
        </BrowserRouter>
    )
}